// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jlnCXwtR{align-items:center;display:flex;margin-top:.25em}.jlnCXwtR input{margin:0 .25em 0 0}.g4PFx46i{margin-left:.5em}`, "",{"version":3,"sources":["webpack://./src/form_components/RadioGroup.module.scss"],"names":[],"mappings":"AAAA,UACE,kBAAA,CACA,YAAA,CACA,gBAAA,CAEA,gBACE,kBAAA,CAIJ,UACE,gBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioOption": `jlnCXwtR`,
	"radioOptions": `g4PFx46i`
};
export default ___CSS_LOADER_EXPORT___;
